import { State } from '@app/models';

export const getRouterSlice = (state: State) => state.router;
